module.exports = __webpack_public_path__ + "img/icon-24-ic-play.c4e01d44.svg";